<script>
  import { navigate } from "svelte-routing";
  import { Badge, Button, Card, Group, Image, Text } from "@svelteuidev/core";
  import ArmazenaVariaveisInscricao from "../Classes/ArmazenaVariaveisInscricao";

  export let imageUrl = "";
  export let navegarPara;
  export let id;
  export let titulo;
  export let descricao;
  export let textinho;
  export let texto_botao;
  export let botao_habilitado;

  function NavegaPara(e) {
    ArmazenaVariaveisInscricao.dados.id_campeonato = id;
    navigate(e);
  }
</script>

<div class="custom-card">
  <Card shadow="sm" padding="xl">
    <Card.Section middle padding="xl" style="display: flex; justify-content: center;">
      <Image src={imageUrl} height={180} width={180} alt={titulo} />
    </Card.Section>
    <Text class="mt-3" weight={"bold"} style="text-align: center;">{titulo}</Text>
    <div class="custom-badge centralizado">
      <Badge class color="pink" variant="light">
        {textinho}
      </Badge>
    </div>

    <Text size="sm" class="mb-2">
      {@html descricao}
    </Text>
    {#if botao_habilitado == 1}
      <Button
        variant="light"
        color="blue"
        on:click={() => NavegaPara(navegarPara)}
        fullSize
      >
        {texto_botao}
      </Button>
    {:else}
      <Button
        variant="outline"
        color="blue"
        on:click={() => NavegaPara(navegarPara)}
        disabled
        fullSize
      >
        {texto_botao}
      </Button>
    {/if}
  </Card>
</div>

<style>
  .custom-card {
    max-width: 300px; /* Ajuste a largura conforme necessário */
    margin-top: 1em; /* Centraliza o card horizontalmente */
  }
  .custom-badge {
    /* Ajuste conforme necessário */
    margin-bottom: 1em; /* Ajuste conforme necessário */
  }

  .centralizado {
    text-align: center;
  }

</style>
